// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topo-container[data-v-0f4f073e]{position:absolute;top:0;left:5px;width:100%;height:100%;overflow:hidden;background-color:transparent}", ""]);
// Exports
module.exports = exports;
